import { createActionGroup, props } from '@ngrx/store';
import { Shop } from '@us/web/shared/data-access';

export const ShopsActions = createActionGroup({
    source: 'Shops/API',
    events: {
        'Load Shops': props<{ lat?: number; lng?: number }>(),
        'Load Shops Success': props<{ shops: Shop[] }>(),
        'Load Shops Failure': props<{ error: string }>(),
        'Select Shop': props<{ shopId: string }>()
    }
});
